// @ts-nocheck
import BaseComponent from "../../common/BaseComponent";
import "./button.scss";

class Buttons extends BaseComponent {
  render() {
    const {
      color,
      disabled,
      size,
      onClick,
      children,
      onMouseEnter,
      onMouseLeave,
      btnClassName = "",
      rowindex,
      onMouseDown,
      testid,
    } = this.props;
    const className = `Button ${color} ${size} ${disabled ? "disabled" : ""} ${btnClassName}`;

    return (
      // @ts-ignore
      <button
        className={className}
        onClick={onClick}
        disabled={disabled}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseDown={onMouseDown}
        rowindex={rowindex}
        data-testid={testid}
      >
        {children}
      </button>
    );
  }
}

export default Buttons;
